import React from "react";
import { MuiPickersUtilsProvider, KeyboardTimePicker } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";

export default function CustomTimePicker(props) {
	const { handleChange, value, data } = props;
	const { label, required, id } = data;
	const now = Date.now();

	const convertHour = () => {
		const now = new Date();
		const [hours, minutes] = value.split(":");
		now.setHours(hours);
		now.setMinutes(minutes);
		return now;
	};

	const timeValue = typeof value === "string" ? convertHour() : value || now;

	const dateHandleChange = (date) => {
		return handleChange({
			target: {
				name: id,
				value: date,
			},
		});
	};
	return (
		<MuiPickersUtilsProvider utils={DateFnsUtils}>
			<KeyboardTimePicker
				fullWidth
				name={id}
				label={label}
				value={timeValue}
				onChange={dateHandleChange}
				KeyboardButtonProps={{
					"aria-label": "change time",
				}}
				required={required}
			/>
		</MuiPickersUtilsProvider>
	);
}
